// extracted by mini-css-extract-plugin
export default {"alfa":"Gabarit_alfa__q4ZVz","btadd":"Gabarit_btadd__9jcQR","creer":"Gabarit_creer__ywu2J","comtnet":"Gabarit_comtnet__o2qaq","fontSize":"Gabarit_fontSize__PIp+3"};